import { CLIENT_ID } from './constants';

/**
 * A customer instance configuration
 */
type InstanceConfiguration = {
  clientId: string;
  loginUrl: string;
  instanceUrl?: string;
};

/**
 * Returns the instance configuration, or default configuration
 * @returns the instance configuration
 */
export const getInstanceConfiguration = (): InstanceConfiguration => {
  const clientId = CLIENT_ID;
  const instanceUrl = localStorage.getItem('instanceUrl') || '';
  const loginUrl = instanceUrl;

  return { clientId, loginUrl, instanceUrl };
};
